(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forgeworn-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gallery = document.querySelector('.fw-product-gallery');
    const mainImage = gallery?.querySelector('.fw-product-image');
    const thumbs = gallery ? gallery.querySelectorAll('.fw-product-thumb') : [];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        const imageUrl = thumb.dataset.image;
        if (!imageUrl) return;
        mainImage.src = imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const guideDialog = document.querySelector('#fw-size-guide-dialog');
    const guideOpen = document.querySelector('.fw-size-guide-open');
    const guideClose = guideDialog ? guideDialog.querySelectorAll('[data-size-guide-close]') : [];
    const closeGuide = () => {
      if (!guideDialog) return;
      guideDialog.hidden = true;
      document.body.classList.remove('fw-size-guide-open');
    };
    if (guideOpen && guideDialog) {
      guideOpen.addEventListener('click', () => {
        guideDialog.hidden = false;
        document.body.classList.add('fw-size-guide-open');
        guideDialog.querySelector('.fw-size-guide-close')?.focus();
      });
      guideClose.forEach((item) => item.addEventListener('click', closeGuide));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeGuide();
      });
    }

    const select = document.querySelector('#fw-variant-select');
    const idInput = document.querySelector('#fw-variant-id');
    const buyNowLabel = document.querySelector('#fw-buy-now-label');
    const addCartLabel = document.querySelector('#fw-add-cart-label');
    if (!select || !idInput) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      idInput.value = option.value;
      const available = option.dataset.available === 'true';
      if (buyNowLabel) buyNowLabel.textContent = available ? 'BUY IT NOW' : 'SOLD OUT';
      if (addCartLabel) addCartLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      document.querySelectorAll('.fw-buy-button').forEach((button) => {
        button.disabled = !available;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
